module.exports = __webpack_public_path__ + "static/media/user-headset.fc14b5a3.svg";